<template>
  <transition>
    <div class="__alert" :class="[type, { margin: margin }]" v-show="visible" role="alert">
      <div class="text" :class="{ center: center }">
        <Icon :name="iconType" margin v-if="icon" />
        <slot />
      </div>

      <div class="close-btn" v-show="closable" @click="close()"><Icon name="times" /></div>
    </div>
  </transition>
</template>

<script>
/*
    Alertコンポーネント
    使い方：<Alert>ここにメッセージを記載</Alert>

    [Props]
    type(String)  : Alertの種類[success/info/warning/danger]。デフォルトは 'info'
    icon(String) : ラベルの前にアイコン挿入。typeによって異なるアイコン。
    center(Boolean) : メッセージを中央表示。
    closable(Boolean) : 閉じるボタンを表示。
    margin(Boolean) : 上下にマージンを追加。

    */

import Icon from './Icon';

export default {
  name: 'Alert',
  components: { Icon },
  props: {
    type: {
      type: String,
      default: 'info',
    },
    icon: Boolean,
    center: Boolean,
    closable: Boolean,
    margin: Boolean,
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    iconType() {
      switch (this.type) {
        case 'success':
          return 'check-circle';
        case 'info':
          return 'info-circle';
        case 'warning':
          return 'exclamation-circle';
        case 'danger':
          return 'times-circle';
        default:
          return 'info-circle';
      }
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/mo-custom';

.__alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  width: 100%;
  margin: 0;
  padding: $padding-sm $padding-md;
  box-sizing: border-box;
  background-color: rgba($neutral-secondary-color, 0.15);
  font-size: $font-size-sm;
  color: $neutral-secondary-color;
  overflow: hidden;
  transition: opacity 0.2s;

  .text {
    width: 100%;
    &.center {
      text-align: center;
    }
  }

  &.margin {
    margin: $margin-md 0;
  }

  .close-btn {
    font-size: $font-size-sm;
    margin-left: $margin-md;
    padding: $padding-sm;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }

  &.success {
    background-color: rgba($success-color, 0.15);
    color: $success-color;
  }
  &.info {
    background-color: rgba($info-color, 0.15);
    color: $info-color;
  }
  &.warning {
    background-color: rgba($warning-color, 0.25);
    color: darken($warning-color, 20%);
  }
  &.danger {
    background-color: rgba($danger-color, 0.15);
    color: $danger-color;
  }
}
</style>
